export const environment = {
    name: 'SANDBOX',
    production: false,
    shopUrl: 'https://shop.junkart.co.uk',
    baseUrl: 'https://sandbox.madkraftz.com',
    apiUrl: 'https://junk-art.appspot.com/api'
};
